import { useManoeuvre } from "../../map/manoeuvre/useManoeuvre";
import { refuseWhileOrienting } from "../../map/manoeuvre/useOrientation";
import { useUi } from "../../state/ui";

/** « Modifier le fuseau » (panneau Manœuvre, fiche d'une limite arrière ou avant de la ZO) : le fuseau et les LIMA
 *  masqués dans les calques réapparaissent, puis le mode édition s'ouvre. */
export function startEditing(): void {
  // Mode orientation ouvert : la retouche attend qu'il soit appliqué ou annulé (« Appliquer » désigné).
  if (refuseWhileOrienting()) return;
  const ui = useUi.getState();
  if (!ui.controlVisible.fuseau) ui.setControlVisible("fuseau", true);
  if (!ui.controlVisible.lima) ui.setControlVisible("lima", true);
  useManoeuvre.getState().setEditing(true);
}

/** « Terminé » du panneau Manœuvre : comme celui du bandeau de la carte, il ne ferme le mode édition qu'une fois
 *  la retouche affichée enregistrée. La carte garde la géométrie de travail (`working`) jusqu'à la réponse du
 *  serveur, et le groupe de flèches en attente part de lui-même au bout de 400 ms : attendre `working === null`
 *  évite de perdre ces flèches et de voir le fuseau retomber sur l'ancienne géométrie le temps de la réponse.
 *  Au-delà de `timeoutMs` (serveur muet), le mode se ferme quand même. */
export function finishEditing(timeoutMs = 6000): Promise<void> {
  return new Promise((resolve) => {
    const store = useManoeuvre;
    if (store.getState().working === null) {
      store.getState().setEditing(false);
      resolve();
      return;
    }
    let settled = false;
    let unsubscribe: () => void = () => undefined;
    const done = () => {
      if (settled) return;
      settled = true;
      unsubscribe();
      clearTimeout(timer);
      if (store.getState().editing) store.getState().setEditing(false);
      resolve();
    };
    const timer = setTimeout(done, timeoutMs);
    unsubscribe = store.subscribe((state) => {
      if (state.working === null || !state.editing) done();
    });
  });
}
